import React from "react";
import PropTypes from "prop-types";
import AgeChart from "../../../../components/atoms/charts/AgeChart";
import Chart from "../../../../components/atoms/charts/Chart";
import ChartsGroup from "../../../../components/atoms/charts/ChartsGroup";

const DataType = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.number,
  })
);

const Charts = (props) => {
  const {
    samplesData,
    sexData,
    vitalData,
    ageData,
    cancerTypeData,
    cancerNameData,
    tumorData,
  } = props;
  return (
    <ChartsGroup>
      <Chart data={samplesData} title="Total samples" showFullChart={true} />
      <Chart data={sexData} title="Sex" />
      <Chart data={vitalData} title="Vital status" />
      <AgeChart data={ageData} title="Age frequency" />
      <Chart data={cancerTypeData} title="Cancer type" />
      <Chart data={cancerNameData} title="Cancer name" />
      <Chart data={tumorData} title="Tumor status" />
    </ChartsGroup>
  );
};

Charts.defaultProps = {
  samplesData: [],
  sexData: [],
  vitalData: [],
  ageData: [],
  cancerTypeData: [],
  cancerNameData: [],
  tumorData: [],
};

Charts.propTypes = {
  samplesData: DataType,
  sexData: DataType,
  vitalData: DataType,
  ageData: DataType,
  cancerTypeData: DataType,
  cancerNameData: DataType,
  tumorData: DataType,
};

export default Charts;
